<script setup lang="ts">
    import { Plus, Minus } from 'lucide-vue-next';
    import { Button } from '@/components/ui/button';
    import { useLogStore } from '@/stores/log';

    const logStore = useLogStore();
</script>

<template>
    <Button
        :variant="logStore.allFiltersOpen ? 'ghost_destructive' : 'ghost'"
        width="narrow"
        class="self-start"
        size="xs"
        @click="logStore.toggleAllFilters"
    >
        {{ logStore.allFiltersOpen ? $t('activities.collapse') : $t('activities.expand') }}
        <Minus
            v-if="logStore.allFiltersOpen"
            class="text-destructive"
        />
        <Plus
            v-else
            class="text-accent"
        />
    </Button>
</template>
